// extracted by mini-css-extract-plugin
export default {"container":"Accessibility_container__gwJD3","block":"Accessibility_block__yAqv0","open":"Accessibility_open__Q7FnT","icon":"Accessibility_icon__MsIn2"};